module.exports = __webpack_public_path__ + "static/Underdown1-3f0a5ecaf199c39ebf30aed1340f064a.png";